<section id="section-loaders" class="container m-t-40">
  <div class="simple-card">
    <p class="h2 p-tb-12 border-bottom m-b-0">Loader</p>

    <div class="row">
      <div class="col-12 col-md-4 m-t-20">
        <button class="btn btn-outline-primary w-100" color="primary" (click)="startProgress()">Start Progress</button>
      </div>

      <div class="col-12 col-md-4 m-t-20">
        <button class="btn btn-outline-primary w-100" color="primary" (click)="startInifiniteLoader()">Start Infinite Loader</button>
      </div>

      <div class="col-12 col-md-4 m-t-20">
        @if (localLoaderIsActive$ | async; as localLoaderIsActive) {
          <button
            class="btn btn-outline-primary w-100"
            color="primary"
            (click)="startLocalLoader()"
            [disabled]="localLoaderIsActive === 'true'"
            >
            @if (localLoaderIsActive === 'true') {
              <local-loader></local-loader>
            } @else {
              Start Local Loader
            }
          </button>
        }
      </div>
    </div>
  </div>
</section>
